import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      CAMPAIGN: "Kampanje",
      SUBSCRIBE: "Abonnér",
      YOU_ARE_SUBSCRIBING_TO: "Du abonnerer på",
      CHANGE: "endre",
      PIECES: "stk",
      ADD: "Legg til",
      REMOVE: "Fjern",
    },
    se: {
      SUBSCRIBE: "Prenumerera",
      CAMPAIGN: "Kampanj",
      YOU_ARE_SUBSCRIBING_TO: "Du prenumererar på",
      CHANGE: "ändra",
      PIECES: "st",
      ADD: "Lägg till",
      REMOVE: "Ta bort",
    },
    dk: {
      SUBSCRIBE: "Abonnér",
      CAMPAIGN: "Kampagne",
      YOU_ARE_SUBSCRIBING_TO: "Du abonnerer på",
      CHANGE: "Rediger",
      PIECES: "stk",
      ADD: "Tilføj",
      REMOVE: "Fjern",
    },
  } as const
)[language];
